import type { MessageKey } from '../en-US/ui';

export const ptBR: Record<MessageKey, string> = {
    // app bar and shell
    'app.name': 'Arcana',
    'app.tagline': 'Tarô para as perguntas que você guarda para si',
    'app.support': 'Apoiar',
    'app.supportAria': 'Apoiar o Arcana',
    'app.language': 'Idioma',
    'app.loading': 'Carregando',
    'app.loadError':
        'Não foi possível carregar este idioma. Confira sua conexão e tente de novo.',
    'app.retry': 'Tentar de novo',
    'app.settings': 'Configurações',
    'app.sound': 'Som e vibração',
    'reminders.title': 'Lembretes',
    'reminders.morning.title': 'Sua carta do dia está à espera',
    'reminders.morning.body':
        'Você ainda não tirou a carta de hoje. Respire fundo e deixe as cartas falarem.',
    'reminders.midnight.title': 'Uma nova leitura está pronta',
    'reminders.midnight.body': 'Um novo dia começou. Venha tirar a sua carta.',
    'reminders.on': 'Lembretes ativados.',
    'reminders.offerTitle': 'Lembretes diários?',
    'reminders.offerBody':
        'Podemos avisar de manhã se você ainda não tirou a sua carta, e à meia-noite quando uma nova leitura estiver pronta.',
    'reminders.notNow': 'Agora não',
    'reminders.channel': 'Lembretes diários',
    'reminders.denied':
        'As notificações estão bloqueadas. Permita-as nas configurações do aparelho para receber lembretes.',
    'reminders.unsupported':
        'Este navegador não consegue mostrar notificações.',
    'reminders.offer': 'Lembrar-me todo dia',
    'reminders.webNote':
        'No navegador, os lembretes chegam enquanto o Arcana está aberto. O app de celular os entrega a qualquer hora.',
    'app.back': 'Voltar',
    'app.close': 'Fechar',
    'app.backHome': '← Voltar ao Arcana',
    'app.getOnMobile':
        'Leve suas leituras para todo lugar, com vibração e seu histórico guardado no celular.',
    'app.getOnMobileButton': 'Baixar no celular',
    'app.getOnMobileTitle': 'Baixe o {name} no seu celular',
    'store.googlePlay': 'Disponível no Google Play',
    'store.appStore': 'Baixe na App Store',
    'store.comingSoon': 'Em breve',
    'store.comingSoonGooglePlay': 'Em breve no Google Play',
    'store.comingSoonAppStore': 'Em breve na App Store',

    // home
    'home.daily.title': 'Carta do dia',
    'home.daily.intro':
        'Uma carta, uma vez por dia. Pergunte o que você mais precisa ouvir e deixe o baralho responder.',
    'home.daily.draw': 'Tirar a carta de hoje',
    'home.daily.sealed':
        'Sua carta já foi tirada e espera, virada para baixo. Um vídeo curto a revela.',
    'home.daily.unlock': 'Revelar a carta de hoje',
    'home.daily.view': 'Ler de novo',
    'home.daily.next': 'O baralho descansa. Próxima carta em {time}',
    'home.daily.sealedFree':
        'Sua carta já foi tirada e espera, virada para baixo. Toque para revelá-la.',
    'home.spreads.title': 'Leituras',
    'home.spreads.note': 'Um vídeo curto abre cada leitura.',
    'home.spreads.noteFree': 'Cada leitura abre na hora, sem anúncios.',
    'home.history': 'Suas leituras',
    'home.breathe': 'Respirar',
    'breathe.title': 'Um momento para respirar',
    'breathe.intro':
        'Escolha um ritmo e acompanhe a esfera. Nada é guardado nem enviado: é só uma pausa.',
    'breathe.pattern.box': 'Quadrada · 4-4-4-4',
    'breathe.pattern.478': '4-7-8',
    'breathe.patternAria': 'Padrão de respiração',
    'breathe.start': 'Começar',
    'breathe.stop': 'Parar',
    'breathe.ready': 'Quando você quiser',
    'breathe.inhale': 'Inspire',
    'breathe.hold': 'Segure',
    'breathe.exhale': 'Expire',
    'breathe.rest': 'Pausa',
    'breathe.note':
        'Uma pausa tranquila, não um tratamento. Vá no seu ritmo e pare quando quiser.',

    // spreads
    'spread.daily.name': 'Carta do dia',
    'spread.love.name': 'Leitura do amor',
    'spread.love.desc':
        'Você, a outra pessoa, o que há entre vocês e o que fazer.',
    'spread.work.name': 'Leitura do trabalho',
    'spread.work.desc': 'Sua situação, o obstáculo e o caminho.',
    'spread.path.name': 'Passado, presente, futuro',
    'spread.path.desc': 'De onde você veio, onde está e o que se aproxima.',
    'spread.yesno.name': 'Sim ou não',
    'spread.yesno.desc': 'Uma pergunta, uma carta, uma resposta direta.',
    'pos.today': 'Hoje',
    'pos.you': 'Você',
    'pos.them': '{name}',
    'pos.bond': 'Entre vocês',
    'pos.guidance': 'Orientação',
    'pos.situation': 'A situação',
    'pos.obstacle': 'O obstáculo',
    'pos.advice': 'O caminho',
    'pos.past': 'Passado',
    'pos.present': 'Presente',
    'pos.future': 'Futuro',
    'pos.answer': 'A resposta',
    'lead.you': 'Assim esta carta fala de você:',
    'lead.them': 'Assim esta carta fala de {name}:',
    'lead.bond': 'Assim esta carta fala do que existe entre vocês:',
    'lead.guidance': 'Isto é o que esta carta convida você a refletir:',
    'lead.situation': 'Assim esta carta descreve onde você está:',
    'lead.obstacle': 'Assim esta carta descreve o que está no seu caminho:',
    'lead.advice': 'Isto é o que esta carta convida você a considerar:',
    'lead.past': 'Olhando para trás, esta carta descreve o que moldou você:',
    'lead.present': 'Esta carta descreve o que cerca você agora:',
    'lead.future': 'Esta carta descreve o que está se formando:',
    'lead.answer': 'Veja por que as cartas respondem assim:',
    'lead.you.rev':
        'Invertida, esta carta fala de um lado seu que está contido ou voltado para dentro:',
    'lead.them.rev':
        'Invertida, esta carta fala de um lado de {name} que está contido ou voltado para dentro:',
    'lead.bond.rev':
        'Invertida, esta carta fala do que está travado ou não dito entre vocês:',
    'lead.guidance.rev':
        'Invertida, esta carta convida você a olhar primeiro para o que está atrapalhando:',
    'lead.situation.rev':
        'Invertida, esta carta descreve uma situação em que algo está preso ou fora de equilíbrio:',
    'lead.obstacle.rev':
        'Invertida, esta carta descreve um obstáculo que talvez seja mais interno do que externo:',
    'lead.advice.rev':
        'Invertida, esta carta convida você a considerar o que precisa se soltar primeiro:',
    'lead.past.rev':
        'Olhando para trás, invertida, esta carta descreve algo que ficou contido ou inacabado:',
    'lead.present.rev':
        'Invertida, esta carta descreve o que parece travado ou por resolver agora:',
    'lead.future.rev':
        'Invertida, esta carta descreve uma tendência que pode emperrar se não for olhada:',
    'lead.answer.rev':
        'Invertida, a carta vira o sentido do avesso. Veja por que as cartas respondem assim:',

    // ritual
    'ritual.name.title': 'Sobre quem é esta leitura?',
    'ritual.name.hint':
        'Um primeiro nome ou apelido. Fica só no seu celular e serve apenas para se dirigir às cartas.',
    'ritual.name.placeholder': 'O nome da pessoa',
    'ritual.name.titleDaily': 'Como você se chama?',
    'ritual.name.hintDaily':
        'Um primeiro nome ou apelido. Você só informa uma vez, fica só no seu celular e serve para a carta do dia falar com você.',
    'ritual.name.placeholderDaily': 'Seu nome',
    'ritual.name.skip': 'Prefiro não dizer',
    'ritual.continue': 'Continuar',
    'ritual.reflect.title': 'Respire. Segure a sua pergunta.',
    'ritual.reflect.titleLove': 'Feche os olhos. Pense em {name}.',
    'ritual.reflect.body.daily':
        'Deixe o barulho do dia assentar. Pergunte, sem palavras se puder: o que preciso saber hoje?',
    'ritual.reflect.body.love':
        'Deixe o rosto, a voz e o jeito como as coisas estão entre vocês surgirem na mente. Não peça um resultado. Peça para compreender.',
    'ritual.reflect.body.work':
        'Traga à mente o trabalho, as pessoas e a pressão. Pergunte o que você ainda não consegue ver de dentro.',
    'ritual.reflect.body.path':
        'Pense na estrada que ficou para trás e na que vem pela frente. Pergunte o que as liga.',
    'ritual.reflect.body.yesno':
        'Segure uma única pergunta, clara e honesta, que possa ser respondida com sim ou não. Faça-a uma vez só.',
    'ritual.breathIn': 'Inspire',
    'ritual.breathHold': 'Segure',
    'ritual.breathOut': 'Solte',
    'ritual.ready': 'Estou pronto(a)',
    'ritual.begin.title': 'O baralho está escutando',
    'ritual.begin.tap': 'Toque no baralho para começar',
    'ritual.charging': 'As cartas estão escolhendo você…',
    'ritual.choose.title': 'Escolha suas cartas',
    'ritual.choose.hintOne':
        'Confie na sua mão. Toque na carta que chama você.',
    'ritual.choose.hintMany':
        'Confie na sua mão. Toque em {count} cartas, uma para cada posição abaixo. Toque numa carta escolhida de novo para devolvê-la.',
    'ritual.choose.card': 'Carta {n}',
    'ritual.choose.confirm': 'Estas são as minhas cartas',
    'ritual.drawn.title': 'Suas cartas foram tiradas',
    'ritual.drawn.body':
        'Elas estão viradas para baixo, já decididas. Um vídeo curto as revela.',
    'ritual.drawn.bodyFree':
        'Elas estão viradas para baixo, já decididas. Revele quando estiver pronto.',
    'ritual.reveal': 'Assistir a um vídeo e revelar',
    'ritual.revealFree': 'Revelar',
    'ritual.opening': 'Abrindo…',
    'ritual.dismissed':
        'O vídeo foi fechado antes do fim. Assista até o final para revelar suas cartas.',
    'ritual.abandon': 'Sair do ritual',

    // reading
    'reading.for': 'Para {name}',
    'reading.tapToTurn': 'Toque em cada carta para virá-la',
    'reading.turnAll': 'Virar todas',
    'reading.reversed': 'Invertida',
    'reading.upright': 'Normal',
    'reading.advice': 'Conselho',
    'reading.dailyAdvice': 'Conselho de hoje',
    'reading.verdict.yes': 'Sim',
    'reading.verdict.no': 'Não',
    'reading.verdict.maybe': 'Ainda não',
    'reading.overallTitle': 'A leitura como um todo',
    'overall.fated':
        'Muitos arcanos maiores e poucas inversões: é um momento de peso, e as cartas falam com clareza.',
    'overall.open':
        'Todas as cartas estão em pé: a energia aqui é aberta e flui livremente. Aja a partir dela.',
    'overall.mixed':
        'Algumas cartas em pé, outras invertidas: há movimento e atrito juntos. Comece pelas cartas invertidas.',
    'overall.blocked':
        'A maioria das cartas está invertida: algo está contido, escondido ou resistido. Desacelere e olhe para dentro antes de agir.',
    'summary.thread.love':
        'Você chega a esta leitura sob “{c0}”, e {name} aparece como “{c1}”. O que vive entre vocês é “{c2}”, e a orientação das cartas vem de “{c3}”. Leia as quatro como uma única história sobre o mesmo laço: cada carta mostra um lado dele, e o sentido da leitura está na conversa entre elas.',
    'summary.thread.work':
        'A situação é “{c0}”, o obstáculo aparece como “{c1}” e o caminho sugerido é “{c2}”. Repare em como a terceira carta responde à segunda: o conselho costuma ser a resposta direta ao que trava o seu passo.',
    'summary.thread.path':
        'O passado traz “{c0}”, o presente vive sob “{c1}” e o futuro aponta para “{c2}”. O futuro aqui é uma tendência, não uma sentença: ele muda conforme o que você faz com o presente. Procure o fio que atravessa as três cartas, o tema que volta com outra roupa.',
    'summary.yesno.yes':
        'A resposta é sim, e ela vem de “{c0}”. Um sim não é promessa: mostra onde o vento sopra a favor, e quem conduz o leme continua sendo você. Talvez valha perguntar o que você precisaria para dizer esse sim por inteiro.',
    'summary.yesno.no':
        'A resposta é não por ora, e ela vem de “{c0}”. Um não não é um veredito sobre você: aponta o que não se encaixa do jeito que está. Talvez valha perguntar o que esse não protege e que pergunta serviria melhor da próxima vez.',
    'summary.yesno.maybe':
        'As cartas ainda não decidem, e “{c0}” mostra por quê. Um ainda não costuma apontar algo imaturo ou ainda não visto. Talvez valha perguntar o que você precisaria saber para responder isto por conta própria.',
    'summary.suit.wands':
        'O naipe de Paus domina esta leitura: o assunto é energia, desejo e ação. A pergunta por trás de tudo é onde você quer colocar o seu fogo.',
    'summary.suit.cups':
        'O naipe de Copas domina esta leitura: o assunto é sentir. Emoção, vínculo e intuição pesam aqui mais do que qualquer argumento.',
    'summary.suit.swords':
        'O naipe de Espadas domina esta leitura: o assunto vive na mente, em pensamentos, palavras e decisões. Separe o que é fato do que é história que você conta.',
    'summary.suit.pentacles':
        'O naipe de Ouros domina esta leitura: o assunto é concreto, feito de tempo, dinheiro, corpo e rotina. Vale o que se constrói devagar e dá para tocar.',
    'summary.reversed.one':
        'A carta invertida, {list}, é o ponto de atenção: o que ela pede costuma estar contido, adiado ou escondido. Comece por ela.',
    'summary.reversed.many':
        'As cartas invertidas ({list}) são os pontos de atenção: o que elas pedem costuma estar contido, adiado ou escondido. Comece por elas.',
    'reading.ask': 'Para sentir com calma',
    'reading.reflect': 'Pergunte a si mesmo(a)',
    'reading.saved': 'Salva nas suas leituras',
    'reading.shareLinkCopied':
        'Link copiado. Nos Stories, cole no adesivo de Link',
    'reading.share': 'Compartilhar',
    'reading.shareFailed': 'Não foi possível criar a imagem',
    'reading.shareDownloaded': 'Imagem salva',
    'reading.shareMessage': 'Minha carta do dia no Arcana',
    'reading.disclaimer':
        'Para reflexão e entretenimento. Uma leitura é um espelho, não uma previsão, e não substitui orientação profissional.',
    'reading.done': 'Fechar a leitura',
    'reading.notFound': 'Esta leitura não está mais salva.',

    // history
    'history.title': 'Suas leituras',
    'history.empty':
        'Nada aqui ainda. Suas leituras ficam guardadas neste celular depois que você as abre.',
    'history.forName': 'para {name}',
    'history.deleteTitle': 'Apagar esta leitura?',
    'history.deleteBody':
        'Ela será removida deste celular e não poderá ser restaurada.',
    'history.cancel': 'Cancelar',
    'history.delete': 'Apagar',

    // reflection questions
    'prompt.general.0':
        'O que mudaria se você confiasse totalmente nesta carta?',
    'prompt.general.1':
        'Com qual parte desta leitura você quis discutir, e por quê?',
    'prompt.general.2': 'Qual pequena ação honraria esta mensagem hoje?',
    'prompt.general.3': 'O que você espera que as cartas não digam?',
    'prompt.general.4': 'Onde na sua vida esta energia já vive?',
    'prompt.general.5':
        'Se este fosse o conselho do seu eu mais sábio, o que você faria em seguida?',
    'prompt.love.0':
        'O que você realmente precisa deste laço, e já disse isso em voz alta?',
    'prompt.love.1':
        'Que parte deste padrão é sua, e que parte é da outra pessoa?',
    'prompt.love.2': 'Se nada na outra pessoa mudasse, o que você escolheria?',
    'prompt.love.3': 'O que você teme que aconteça se disser a verdade?',
    'prompt.love.4':
        'O que este amor ensinou sobre como você deseja ser amado(a)?',
    'prompt.love.5':
        'Como seria a ternura com você e com a outra pessoa nesta semana?',
    'prompt.work.0':
        'O que você faria aqui se não tivesse medo de ser julgado(a)?',
    'prompt.work.1':
        'Qual obstáculo é real, e qual é uma história que você conta?',
    'prompt.work.2': 'Como seria um ano neste caminho, e você o quer?',
    'prompt.work.3': 'Quem poderia ajudar você, e o que impede de pedir?',
    'prompt.work.4':
        'Qual o menor próximo passo que você poderia dar até o fim da semana?',
    'prompt.work.5': 'O que você tolera que já deixou para trás?',

    // ads
    'ads.advertisement': 'Publicidade',
    'ads.footerPreview': 'Prévia do anúncio do rodapé',
    'ads.breakTitle': 'Uma pausa curta · mantém o Arcana gratuito',
    'ads.breakPreview': 'Prévia do intervalo de anúncio',
    'ads.continue': 'Revelar',
    'ads.continueIn': 'Revelar em {seconds}s',
    'footer.about': 'Sobre',
    'footer.privacy': 'Privacidade',

    // support
    'support.title': 'Apoie o Arcana',
    'support.intro':
        'O Arcana é feito por uma pessoa só. Os anúncios o mantêm gratuito; uma gorjeta o mantém crescendo, com novas leituras e mais profundidade em cada carta.',
    'support.owned':
        'Você tem o desbloqueio vitalício: sem anúncios, para sempre. Obrigado, de coração.',
    'support.lifetime': 'Remover anúncios para sempre · {price}',
    'support.lifetimeHint':
        'Um único pagamento, sem assinatura. Remove todos os anúncios de vez, nesta conta da loja.',
    'support.restore': 'Restaurar uma compra anterior',
    'support.noAds':
        'Quer ficar sem anúncios? O app para Android tem um desbloqueio vitalício único.',
    'support.coffee': '☕ Me pague um café',
    'support.pix': '🇧🇷 Pix (Mercado Pago)',
    'support.noLink': 'O link de gorjeta ainda não foi configurado.',
    'support.noAccount': 'Sem conta, sem login.',
    'support.about': 'Sobre',
    'support.privacy': 'Política de privacidade',
    'support.close': 'Fechar',

    // about
    'about.title': 'Sobre o Arcana',
    'about.intro':
        'O Arcana é um app de tarô com o baralho completo de 78 cartas: os 22 arcanos maiores e os quatro naipes dos arcanos menores. Oferece uma carta do dia, uma leitura do amor, uma leitura do trabalho, uma tiragem de passado-presente-futuro e uma carta de sim ou não, em português e inglês.',
    'about.howTitle': 'Como funciona uma leitura',
    'about.how1':
        'As cartas são embaralhadas com o gerador aleatório seguro do seu aparelho, então cada tiragem é realmente aleatória, e uma carta pode sair em pé ou invertida.',
    'about.how2':
        'O significado de cada carta é escrito à mão e depende da posição na tiragem e do tema: amor, trabalho ou orientação geral. Nenhuma inteligência artificial escreve a sua leitura, e nada do que você digita sai do seu celular.',
    'about.how3':
        'O tarô é uma ferramenta de reflexão. Ele não prevê o futuro e não é orientação médica, jurídica, financeira ou psicológica.',
    'about.creditsTitle': 'Arte das cartas',
    'about.credits':
        'As imagens das cartas são do baralho Rider-Waite-Smith, ilustrado por Pamela Colman Smith em 1909 e publicado por William Rider & Son. A arte é de domínio público; as digitalizações vêm do Wikimedia Commons.',
    'about.faqTitle': 'Perguntas',
    'about.q1': 'Por que só posso tirar a carta do dia uma vez por dia?',
    'about.a1':
        'O ritual tem significado porque é raro. Sua carta fica legível até a meia-noite pelo relógio do celular, e então o baralho está pronto de novo.',
    'about.q2': 'Por que um vídeo antes de cada leitura?',
    'about.a2':
        'O Arcana é gratuito, e o vídeo curto o sustenta. Se preferir não assistir, o app para Android tem uma compra única que remove todos os anúncios. Suas cartas são tiradas antes, então fechar o app não as muda.',
    'about.q3': 'Onde minhas leituras ficam guardadas?',
    'about.a3':
        'Só no seu celular. Não há contas nem servidores. Desinstalar o app as apaga.',
    'about.q4': 'Como entro em contato?',
    'about.a4': 'Escreva para',

    // privacy
    'privacy.consent':
        'Na União Europeia, no Reino Unido e na Suíça pedimos o seu consentimento antes de mostrar anúncios, por meio do formulário de consentimento do Google, no app Android e no site. Você pode mudar sua escolha a qualquer momento: no app Android, pelo botão abaixo; no site, pelo botão de configurações de privacidade que o Google exibe.',
    'privacy.adChoices': 'Escolhas de privacidade de anúncios',
    'privacy.title': 'Política de Privacidade',
    'privacy.intro':
        'O Arcana é um app pequeno que respeita a sua privacidade. Esta política explica o que é guardado, o que é compartilhado e por quê. Ao usar o Arcana você concorda com ela.',
    'privacy.deviceTitle': 'O que fica no seu aparelho',
    'privacy.p1':
        'Suas leituras, os nomes que você digita nas leituras de amor, os dados de nascimento informados para o mapa astral (data, hora e local), seu idioma e sua configuração de som ficam armazenados somente no seu aparelho. O Arcana não tem contas nem servidor, então nunca os recebemos. Desinstalar o app ou limpar seus dados os apaga. Uma exceção: se o local que você digita para o mapa astral não estiver na lista de cidades do app, só o texto do local é enviado ao Photon (photon.komoot.io, dados do OpenStreetMap) para encontrá-lo. Sua data, hora e nome nunca são enviados.',
    'home.journal': 'Diário de gratidão',
    'journal.title': 'Diário de gratidão',
    'journal.today': 'Pergunta de hoje',
    'journal.placeholder': 'Uma linha basta',
    'journal.save': 'Salvar',
    'journal.saved': 'Salvo para hoje. Você pode editar até meia-noite.',
    'journal.streak': '{n} dias seguidos',
    'journal.streak0': 'Ainda sem sequência',
    'journal.past': 'Entradas anteriores',
    'journal.empty': 'Nada escrito ainda.',
    'journal.export': 'Exportar',
    'journal.deleteAll': 'Apagar tudo',
    'journal.confirmTitle': 'Apagar o diário inteiro?',
    'journal.confirmBody': 'Todas as entradas são apagadas deste aparelho. Isso não pode ser desfeito.',
    'journal.cancel': 'Cancelar',
    'journal.confirm': 'Apagar',
    'journal.privacy': 'Privado: as entradas ficam neste aparelho e nunca saem dele.',
    'journal.prompt0': 'O que de pequeno foi bom hoje?',
    'journal.prompt1': 'Quem você está feliz por ter na sua vida agora?',
    'journal.prompt2': 'O que saiu melhor do que você esperava?',
    'journal.prompt3': 'O que de comum você sentiria falta se não existisse?',
    'journal.prompt4': 'O que seu corpo permitiu que você fizesse hoje?',
    'journal.prompt5': 'Qual momento você teria prazer em viver de novo?',
    'privacy.journal': 'Seu diário de gratidão fica armazenado somente no seu aparelho, no mesmo armazenamento local das suas configurações. As entradas nunca são enviadas a lugar nenhum. Você pode exportá-las ou apagá-las todas na tela do diário a qualquer momento.',
    'privacy.adsTitle': 'Publicidade',
    'privacy.p2a':
        'O Arcana é mantido por anúncios do Google (AdMob no app de celular, AdSense na web). O Google pode usar identificadores e cookies para exibir e medir anúncios, e pode personalizá-los. Você pode gerenciar isso nas',
    'privacy.googleSettings': 'configurações de anúncios do Google',
    'privacy.p2b': 'e saber como o Google usa dados em',
    'privacy.p3':
        'A menos que você tenha comprado o desbloqueio único sem anúncios, um vídeo com recompensa é exibido antes de cada leitura ser revelada. A compra é processada pelo Google Play; nós nunca vemos seus dados de pagamento. Nenhum outro dado é enviado a nós.',
    'privacy.ageTitle': 'Idade',
    'privacy.age':
        'O Arcana é destinado a adultos. Não é direcionado a menores de 18 anos.',
    'privacy.changesTitle': 'Mudanças nesta política',
    'privacy.changes':
        'Se esta política mudar, o novo texto e sua data aparecerão nesta página.',
    'privacy.contactTitle': 'Fale conosco',
    'privacy.contact': 'Se tiver dúvidas sobre esta política, escreva para',
    'privacy.updated': 'Última atualização: {date}',

    // birth chart
    'home.hello': 'Olá, {name}',
    'home.helloAnon': 'Olá',
    'home.chart.name': 'Mapa astral',
    'home.chart.desc':
        'O céu no momento em que você nasceu: Sol, Lua, ascendente, planetas e casas.',
    'chart.title': 'Mapa astral',
    'chart.intro':
        'Informe quando e onde você nasceu. Os planetas são posicionados a partir de dados astronômicos; o ascendente e as casas dependem também da hora e do local exatos.',
    'chart.name': 'Nome (opcional)',
    'chart.date': 'Data de nascimento',
    'chart.time': 'Hora de nascimento',
    'chart.timeUnknown': 'Não sei a hora em que nasci',
    'chart.timeUnknownHint':
        'Sem a hora de nascimento não é possível achar o ascendente nem as casas. O mapa é feito para o meio-dia.',
    'chart.place': 'Cidade de nascimento',
    'chart.placeHint': 'Comece a digitar uma cidade',
    'chart.placeLoading': 'Carregando cidades…',
    'chart.placeSearching': 'Buscando…',
    'chart.placeNone':
        'Nenhuma cidade encontrada. Tente outra grafia ou informe as coordenadas.',
    'chart.placeChosen': 'Fuso horário: {zone}',
    'chart.manual': 'Informar coordenadas',
    'chart.manualBack': 'Buscar uma cidade',
    'chart.manualPlace': 'Nome do local (opcional)',
    'chart.manualLat': 'Latitude (norte positiva, sul negativa)',
    'chart.manualLon': 'Longitude (leste positiva, oeste negativa)',
    'chart.manualZone': 'Fuso horário (por exemplo America/Sao_Paulo)',
    'chart.error.date': 'Informe uma data de nascimento válida.',
    'chart.error.time':
        'Informe a hora de nascimento ou marque que não a sabe.',
    'chart.error.place': 'Escolha a cidade de nascimento na lista.',
    'chart.error.lat': 'A latitude deve ser um número de -90 a 90.',
    'chart.error.lon': 'A longitude deve ser um número de -180 a 180.',
    'chart.error.zone':
        'Esse fuso horário não é conhecido. Use um nome como Europe/Lisbon.',
    'chart.error.calc':
        'Não foi possível calcular este mapa. Confira a data, a hora e o local.',
    'chart.submit': 'Revelar meu mapa',
    'chart.unlockNote': 'Um vídeo curto abre o seu mapa.',
    'chart.unlockNoteFree': 'O seu mapa abre na hora, sem anúncios.',
    'chart.anotherHintFree': 'Para você ou para outra pessoa.',
    'chart.dismissed':
        'O vídeo foi fechado antes do fim, então o mapa continua lacrado. Tente de novo quando quiser.',
    'chart.saved': 'Seus mapas',
    'chart.mine': 'Meu mapa',
    'chart.delete': 'Apagar',
    'chart.cancel': 'Cancelar',
    'chart.deleteTitle': 'Apagar este mapa?',
    'chart.deleteBody':
        'Os dados de nascimento são apagados deste aparelho. Você pode informá-los de novo quando quiser.',
    'chart.new': 'Novo mapa',
    'chart.notFound': 'Este mapa não está mais salvo.',
    'chart.heading': 'Mapa de {name}',
    'chart.born': 'Nascimento: {date}, {time}, em {place}',
    'chart.bornNoTime': 'Nascimento: {date}, em {place}, hora desconhecida',
    'chart.zone': 'A hora local era UTC{offset} ({zone})',
    'chart.wheel': 'Roda do mapa astral',
    'chart.bigThree': 'Seus três principais',
    'chart.another': 'Calcular outro mapa',
    'chart.anotherHint':
        'Para você ou para outra pessoa. Cada novo mapa exige um vídeo curto.',
    'chart.sun': 'Sol',
    'chart.moon': 'Lua',
    'chart.rising': 'Ascendente',
    'chart.ruler': 'O regente do seu mapa',
    'chart.placements': 'Planetas e pontos',
    'chart.angles': 'Ângulos',
    'chart.house': 'Casa {n}',
    'chart.retrograde': 'retrógrado',
    'chart.aspects': 'Aspectos',
    'chart.system.placidus': 'Casas Placidus',
    'chart.system.whole-sign': 'Casas por signo inteiro',
    'chart.warn.noTime':
        'Sem a hora de nascimento, o mapa é feito para o meio-dia e não tem ascendente, ângulos nem casas. A Lua anda cerca de 13 graus por dia, então sua posição é aproximada.',
    'chart.warn.ambiguous-time':
        'Os relógios foram atrasados nesta hora, então este horário local aconteceu duas vezes. Usamos o primeiro. Se você nasceu na segunda vez, o ascendente será diferente.',
    'chart.warn.skipped-time':
        'Os relógios foram adiantados nesta hora, então este horário local não existiu. Usamos a hora anterior à mudança.',
    'chart.warn.polar-fallback':
        'As casas Placidus não existem tão perto do polo. Foram usadas casas por signo inteiro.',
    'chart.warn.moon-sign-uncertain':
        'A Lua mudou de signo durante este dia, então o signo dela depende da hora de nascimento.',
    'chart.accuracy':
        'Os planetas são calculados a partir de posições astronômicas, com precisão de uma fração de grau. O ascendente avança cerca de um grau a cada quatro minutos, então uma hora de nascimento errada por alguns minutos pode mudar o grau e, às vezes, o signo.',
    // sleep sounds
    'home.sleep.name': 'Sons para dormir',
    'home.sleep.desc':
        'Chuva, ruído marrom e oceano, gerados no seu aparelho, com timer para dormir.',
    'sleep.title': 'Sons para dormir',
    'sleep.intro':
        'Deixe o dia assentar. Deslize para definir o timer e escolha um som para abrir o portal.',
    'sleep.rain': 'Chuva',
    'sleep.brown': 'Ruído marrom',
    'sleep.ocean': 'Oceano',
    'sleep.timer': 'Timer para dormir',
    'sleep.minutes': '{n} min',
    'sleep.hours': '{n} h',
    'sleep.hoursMinutes': '{h} h {m} min',
    'sleep.remaining': 'O som se apaga em {time}',
    'sleep.stop': 'Parar',
    'sleep.declined': 'Assista ao vídeo até o fim para abrir os sons.',
    'sleep.note':
        'Um vídeo curto abre os sons nesta sessão. Mantenha o app aberto e a tela ligada enquanto ouve.',
    'sleep.noteFree':
        'Sem anúncios. Mantenha o app aberto e a tela ligada enquanto ouve.',
    'sleep.noteBackground':
        'Um vídeo curto abre os sons nesta sessão. O som continua com a tela desligada; pare por aqui ou pela notificação.',
    'sleep.noteBackgroundFree':
        'Sem anúncios. O som continua com a tela desligada; pare por aqui ou pela notificação.',
    'about.creditsChart':
        'Os mapas astrais usam posições planetárias da Astronomy Engine (Don Cross, licença MIT), coordenadas e fusos horários de cidades do GeoNames (geonames.org, CC BY 4.0) o banco de fusos horários IANA do seu aparelho e, para locais fora da lista do app, o Photon com © colaboradores do OpenStreetMap (ODbL).',
};
